import axios, { AxiosResponse } from "axios";

/**
 * Обновление тоукена авторизации
 */
export const refreshToken = (): Promise<AxiosResponse<void>> => {
    return axios.post<void>('/site/default/master/isna-portal-cms/_/service/isnareactcms/user', {
        action: 'refresh_token',
    });
};

/**
 * Получить время жизни тотукена
 */
export const getTokenTime = (): Promise<AxiosResponse<number>> => {
    return axios.get<number>('/services/isnaportal/open-api/keycloak/access-token-lifespan');
};
